import { da, enUS } from "date-fns/locale";

export default function (user) {
  if (user.language === "da") {
    return { locale: da };
  } else {
    return { locale: enUS };
  }
}
